import colors from '@/colors-palette';
import { User, Workspace } from '@/graphql/generated/types.generated';
import { getTimezoneOffsetString } from '@/utils/timezone-offset-string.util';
import { InfoOutlined } from '@mui/icons-material';
import { Alert, Tooltip, Typography } from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';

type PostScheduleTimezoneAlertProps = {
    date: Dayjs | null;
    userTimezone: User['timezone'];
    workspaceTimezone: Workspace['timezone'];
    isTooltip?: boolean;
};
const PostScheduleDateTimezoneAlert = ({
    date,
    userTimezone,
    workspaceTimezone,
    isTooltip,
}: PostScheduleTimezoneAlertProps) => {
    const { t } = useTranslation();

    if (userTimezone?.id === workspaceTimezone?.id) {
        return null;
    }

    if (isTooltip) {
        return (
            <Tooltip
                title={t('schedule.timezone-info', {
                    date: dayjs(date).tz(userTimezone?.timezone).format('L LT'),
                    timezone: `${t(workspaceTimezone?.timezoneKey || '', { ns: 'timezones' })} ${getTimezoneOffsetString(
                        workspaceTimezone?.timezone || 'UTC',
                    )}`,
                })}
            >
                <InfoOutlined sx={{ color: colors.indigo[600] }} fontSize="small" />
            </Tooltip>
        );
    }

    return (
        <Alert
            severity="info"
            icon={<InfoOutlined sx={{ color: colors.indigo[600] }} fontSize="small" />}
            sx={{
                padding: (theme) => theme.spacing(0.5, 2),
                bgcolor: 'var(--mui-palette-secondary-_states-selected)',
                border: 1,
                borderColor: 'var(--mui-palette-secondary-_states-outlinedBorder)',
                color: colors.indigo[600],
                alignItems: 'center',
                '& .MuiAlert-message': { p: 0 },
                '& .MuiAlert-icon': { p: 0 },
                borderRadius: (theme) => theme.spacing(1),
                my: 1,
            }}
        >
            {
                <Typography variant="caption">
                    {t('schedule.timezone-info', {
                        date: dayjs(date).tz(userTimezone?.timezone).format('L LT'),
                        timezone: `${t(workspaceTimezone?.timezoneKey || '', { ns: 'timezones' })} ${getTimezoneOffsetString(
                            workspaceTimezone?.timezone || 'UTC',
                        )}`,
                    })}
                </Typography>
            }
        </Alert>
    );
};
export default PostScheduleDateTimezoneAlert;
